import {
  AccordionItem as AccordionItemWrapper,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState
} from 'react-accessible-accordion';

import Icon from '@/components/global/Icon';
import { useScreenSize } from '@/lib/hooks/mediaQuery';

import styles from './Accordion.module.scss';

interface IAccordionItem {
  title: string;
  uid: string;
  iconColor?: string;
  iconSize?: string;
  titleHeading?: React.ElementType;
}

const Arrow = ({ expanded, color, iconSize }: any) => {
  const screen = useScreenSize();
  const _iconSize = iconSize ? iconSize : screen === 'Mobile' ? '16' : '24';
  return (
    <div className={styles.arrow}>
      {expanded ? (
        <Icon color={color} iconName="arrow-up" width={_iconSize} height={_iconSize} />
      ) : (
        <Icon color={color} iconName="arrow-down" width={_iconSize} height={_iconSize} />
      )}
    </div>
  );
};

const AccordionItem: React.FC<IAccordionItem> = ({
  titleHeading = 'h5',
  children,
  title,
  uid,
  iconColor,
  iconSize
}) => {
  const Heading = titleHeading;
  return (
    <AccordionItemWrapper uuid={uid} className={styles.accordionItem}>
      <AccordionItemHeading>
        <AccordionItemButton>
          <div className={styles.heading}>
            <div className={styles.title}>
              <Heading>{title}</Heading>
            </div>
            <AccordionItemState>
              {(state) => <Arrow color={iconColor} expanded={state.expanded} iconSize={iconSize} />}
            </AccordionItemState>
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel className={styles.accordionItemPanel}>{children}</AccordionItemPanel>
    </AccordionItemWrapper>
  );
};
export default AccordionItem;
